import { render, staticRenderFns } from "./data_order.vue?vue&type=template&id=0b7f7246&scoped=true&"
import script from "./data_order.vue?vue&type=script&lang=js&"
export * from "./data_order.vue?vue&type=script&lang=js&"
import style0 from "./data_order.vue?vue&type=style&index=0&id=0b7f7246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f7246",
  null
  
)

export default component.exports